<div class="main-container">
    <img class="close-ic" src="assets/images/icons/close_icon.svg" alt="" mat-dialog-close>
    <div class="icon-logo">
        <img src="assets/images/icons/job_summary.png" class="img-fluid" alt="">
    </div>
    <h6 class="mt-3 mb-3"> Shift Summary</h6>

    <div class="details-div">
        <div class="d-flex justify-content-between gap-5">
            <div>
                <div class="d-flex gap-10 align-items-center">
                    <div class="title white-space-no-wrap">Job Title:</div>
                    <div class="sub-title ">{{dialogData?.formData.j_n}}</div>
                </div>
                <div class="d-flex gap-10 align-items-center">
                    <div class="title white-space-no-wrap">Category :</div>
                    <div class="sub-title">{{dialogData?.formData.j_c}}</div>
                </div>
                <div class="d-flex gap-10 align-items-center">
                    <div class="title white-space-no-wrap">Sub Category :</div>
                    <div class="sub-title">{{dialogData?.formData.j_sc}}</div>
                </div>
            </div>
            <div>
                <div class="d-flex gap-10 align-items-center">
                    <div class="title white-space-no-wrap">Job Quantity :</div>
                    <div class="sub-title">{{dialogData?.formData.qty}}</div>
                </div>
                <div class="d-flex gap-10 align-items-center">
                    <div class="title white-space-no-wrap">Instant Hire :</div>
                    <div class="sub-title">{{dialogData?.formData.ins_h=='true' ? 'yes':'no'}}</div>
                </div>
                <div class="d-flex gap-10 align-items-center">
                    <div class="title white-space-no-wrap">Min Shift Hours:</div>
                    <div class="sub-title">{{dialogData?.formData.mi_sh}}</div>
                </div>
            </div>
        </div>
        <div class="mt-5 mb-5">
            <div class="t-header">
                <div class="date">Date</div>
                <div class="start-time">Start Time</div>
                <div class="end-time">End Time</div>
            </div>
            <div class="t-data" *ngFor="let item of dialogData.formData.date">
                <div class="date">{{item.display_dt}}</div>
                <div class="start-time" *ngIf="dialogData?.formData.all_day==false">{{item?.s_sti}}</div>
                <div class="end-time" *ngIf="dialogData?.formData.all_day==false">{{item?.e_eti}}</div>
                <div class="start-time" *ngIf="dialogData?.formData.all_day==true">All day</div>
            </div>
            <div class="total-tr">
                <div class="d-flex gap-10 align-items-center">
                    <div class="title white-space-no-wrap">Hourly Rate :</div>
                    <div class="sub-title">{{wagesDataHr}}/hr</div>
                </div>
                <div class="d-flex gap-10 align-items-center">
                    <div class="title">Total approximated Expense :</div>
                    <div class="sub-title white-space-no-wrap">{{wagesData}} €</div>
                </div>
            </div>
        </div>
        <div class="d-flex gap-10 ">
            <div class="title">Notes :</div>
            <div class="sub-title">{{dialogData?.formData.notes}}</div>
        </div>
        <div class="d-flex gap-10 ">
            <div class="title white-space-no-wrap">Dress Code :</div>
            <div class="sub-title">{{dialogData?.formData.dr_c}}</div>
        </div>
        <div class="d-box">
            <button mat-raised-button color="primary" class="btn btn-primary mt-4 mt-lg-5" type="submit"
                (click)="onSubmit()" style="min-width: 180px;">{{"BUTTON.SAVE" | translate }} </button>
        </div>
    </div>
</div> 